import React from "react";
import DocsCards from "./DocsCards";

const handleDownload = async (uri, nombre) => {
  try {
    const response = await fetch(uri);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = nombre;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(uri, "_blank", "noopener,noreferrer");
  }
};

const DocumentsAuthorizationsGrid = ({ documents }) => (
  <DocsCards
    items={documents ?? []}
    getName={(d) => d.Nombre ?? d.nombre ?? ""}
    getDate={(d) => d.fecha}
    onDownload={(d) => handleDownload(d.Uri ?? d.uri, d.Nombre ?? d.nombre)}
    emptyMessage="No hay documentos de autorizaciones."
  />
);

export default DocumentsAuthorizationsGrid;
